import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHandoverByOrganizationIdsQueryVariables = Types.Exact<{
  organization_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetHandoverByOrganizationIdsQuery = { __typename?: 'query_root', handover: Array<{ __typename?: 'handover', id: any, project_name: string, project_description?: string | null, status: string, vendor_device_notes?: string | null, requester_notes?: string | null, created_at?: any | null, updated_at?: any | null, published_at?: any | null, vendor_organization_id?: any | null, customer_organization_id?: any | null, property_id?: any | null, created_by_user_id: string, vendor_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, customer_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, organization_id: any, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null } | null, requester?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null, guides: Array<{ __typename?: 'guides', id: any, handover_id?: any | null, updated_at: any, title?: string | null, status: string, description?: string | null, video_url?: string | null, thumbnail_url?: string | null, thumbnail_timestamp_ms?: any | null, created_by_user_id?: string | null, organization_id?: any | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, title: string, body?: string | null, image_url?: string | null, video_url?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, photo_link?: string | null, installed_products: Array<{ __typename?: 'installed_products', id: any, property_id: any, photo_link?: string | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null }> } | null }> }>, property_documents: Array<{ __typename?: 'property_documents', id: any, property_id: any, name?: string | null, mime_type?: string | null, document_link?: string | null, photo_link?: string | null, video_link?: string | null, handover_id?: any | null }>, device_detection_jobs: Array<{ __typename?: 'device_detection_jobs', id: any, workspace_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, handover_id?: any | null, created_at?: any | null, updated_at: any, property_id: any, organization_id?: any | null, created_by_user_id?: string | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, author?: { __typename?: 'users', first_name: string, last_name: string, email: string } | null }>, user_invitations: Array<{ __typename?: 'user_invitations', id: any, email: string, role?: string | null, status: string, message?: string | null, properties_ids?: Array<string> | null, organization_id?: any | null, sender_id?: string | null, handover_id?: any | null, sender?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null }> }> };


export const GetHandoverByOrganizationIdsDocument = gql`
    query getHandoverByOrganizationIds($organization_ids: [uuid!]) {
  handover(
    where: {_or: [{customer_organization_id: {_in: $organization_ids}}, {vendor_organization_id: {_in: $organization_ids}}]}
    order_by: {updated_at: desc}
  ) {
    id
    project_name
    project_description
    status
    vendor_device_notes
    requester_notes
    project_description
    created_at
    updated_at
    published_at
    vendor_organization_id
    vendor_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    customer_organization_id
    customer_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      organization_id
    }
    created_by_user_id
    requester {
      id
      first_name
      last_name
      role
      email
      organization_id
    }
    guides {
      id
      handover_id
      updated_at
      title
      status
      description
      video_url
      thumbnail_url
      thumbnail_timestamp_ms
      guide_steps {
        id
        title
        body
        image_url
        video_url
      }
      product_guides {
        id
        product {
          id
          photo_link
          installed_products(distinct_on: property_id) {
            id
            property_id
            photo_link
          }
          product_attachments {
            id
            photo_link
          }
        }
      }
      created_by_user_id
      organization_id
    }
    property_documents {
      id
      property_id
      name
      mime_type
      document_link
      photo_link
      video_link
      handover_id
    }
    device_detection_jobs {
      id
      workspace_id
      status
      input_files
      ai_response
      detected_devices
      detected_installed_products
      products_grouped_by_type
      handover_id
      created_at
      updated_at
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        photo_link
      }
      organization_id
      organization {
        id
        name
        type
        organizationImageURL
      }
      created_by_user_id
      author {
        first_name
        last_name
        email
      }
    }
    user_invitations {
      id
      email
      role
      status
      message
      properties_ids
      organization_id
      sender_id
      sender {
        id
        first_name
        last_name
        role
        email
        organization_id
      }
      handover_id
    }
  }
}
    `;

/**
 * __useGetHandoverByOrganizationIdsQuery__
 *
 * To run a query within a React component, call `useGetHandoverByOrganizationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoverByOrganizationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoverByOrganizationIdsQuery({
 *   variables: {
 *      organization_ids: // value for 'organization_ids'
 *   },
 * });
 */
export function useGetHandoverByOrganizationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>(GetHandoverByOrganizationIdsDocument, options);
      }
export function useGetHandoverByOrganizationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>(GetHandoverByOrganizationIdsDocument, options);
        }
export function useGetHandoverByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>(GetHandoverByOrganizationIdsDocument, options);
        }
export type GetHandoverByOrganizationIdsQueryHookResult = ReturnType<typeof useGetHandoverByOrganizationIdsQuery>;
export type GetHandoverByOrganizationIdsLazyQueryHookResult = ReturnType<typeof useGetHandoverByOrganizationIdsLazyQuery>;
export type GetHandoverByOrganizationIdsSuspenseQueryHookResult = ReturnType<typeof useGetHandoverByOrganizationIdsSuspenseQuery>;
export type GetHandoverByOrganizationIdsQueryResult = Apollo.QueryResult<GetHandoverByOrganizationIdsQuery, GetHandoverByOrganizationIdsQueryVariables>;